import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { NgFor } from '@angular/common';

export type OpcaoMenuSuspenso = {
  rotulo: string;
  icone: string;
  acao: string;
};

@Component({
  selector: 'app-menu-suspenso',
  standalone: true,
  imports: [MatIconModule, MatMenuModule, NgFor],
  templateUrl: './menu-suspenso.component.html',
  styleUrl: './menu-suspenso.component.scss',
})
export class MenuSuspensoComponent {
  @Output() chamadaDeAcao = new EventEmitter<string>();
  @Input() opcoes: OpcaoMenuSuspenso[] = [];

  chamarAcao(acao: string) {
    this.chamadaDeAcao.emit(acao);
  }
}
